
import type { PropType } from 'vue'
import { defineComponent } from 'vue'

export default defineComponent({
    props: {
        status: {
            type: Object as PropType<{ id: number; name: string; } | null>,
            default: null
        },
    },
    setup(props) {
        const getColor = () => {
            if (props.status) {
                if (props.status.id === 60) {
                    return 'green'
                }

                if (props.status.id === 61) {
                    return 'red'
                }

                if (props.status.id === 62) {
                    return 'orange'
                }
            }

            return 'gray'
        }

        return {
            getColor
        }
    }
})
